import { StoreName } from '../../constants';
import { createWithEqualityFn } from '../createWithEqualityFn';
import { MiddlewaresList, withMiddleware } from '../middleware';
import { withSmartSelectors } from '../withSmartSelectors';

export const createBaseStore = <State>(
  storeName: StoreName,
  initialState: State,
  middlewares?: MiddlewaresList<State>
) => {
  const storeHook = createWithEqualityFn(
    withMiddleware<State>(() => initialState, storeName, middlewares)
  );

  return withSmartSelectors(storeHook);
};
